import React from 'react';

import type { NextPageWithLayout } from 'nextjs/types';

import PageNextJs from 'nextjs/PageNextJs';

import config from 'configs/app';
import NirmalxHome from 'ui/nirmalx/home/NirmalxHome';
import LayoutNirmalxHome from 'ui/nirmalx/layout/LayoutNirmalxHome';
import OpSuperchainHome from 'ui/optimismSuperchain/home/OpSuperchainHome';

const Page: NextPageWithLayout = () => {
  return (
    <PageNextJs pathname="/">
      { config.features.opSuperchain.isEnabled ? <OpSuperchainHome/> : <NirmalxHome/> }
    </PageNextJs>
  );
};

Page.getLayout = function getLayout(page: React.ReactElement) {
  return (
    // NirmalX: the custom home page and shell (ui/nirmalx); other pages keep the Blockscout layout for now.
    <LayoutNirmalxHome>
      { page }
    </LayoutNirmalxHome>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps/main';
